import type { ReactNode } from "react";

import { CommandPaletteProvider } from "@/common/components/command-palette";
import { GlobalShortcutsProvider } from "@/common/components/global-shortcuts";
import { SidebarProvider as AppSidebarProvider } from "@/common/hooks/useSidebar";
import SmartSidebar from "@/common/layouts/SmartSidebar";
import { BackgroundGenerationProvider } from "@/common/providers/BackgroundGenerationProvider";
import { RequirementBackgroundGenerationProvider } from "@/common/providers/RequirementBackgroundGenerationProvider";
import UpgradeNudgeBanner from "@/components/billing/UpgradeNudgeBanner";

import "@/common/styles/styles.css";

interface LayoutProps {
  children: ReactNode;
}

const GlobalLayout = ({ children }: LayoutProps) => {
  return (
    <AppSidebarProvider>
      <CommandPaletteProvider>
        <GlobalShortcutsProvider>
          <BackgroundGenerationProvider>
            <RequirementBackgroundGenerationProvider>
              <div className="flex h-svh w-full bg-background dark:bg-transparent text-foreground antialiased">
                <SmartSidebar />
                <div className="flex min-w-0 flex-1 flex-col">
                  {/* Free-plan upgrade nudge (renders only when conditions match) */}
                  <UpgradeNudgeBanner />
                  <div
                    id="main-content"
                    className="flex-1 h-full min-h-0 min-w-0 overflow-auto custom-scrollbar bg-background dark:bg-transparent"
                  >
                    {children}
                  </div>
                </div>
              </div>
            </RequirementBackgroundGenerationProvider>
          </BackgroundGenerationProvider>
        </GlobalShortcutsProvider>
      </CommandPaletteProvider>
    </AppSidebarProvider>
  );
};

export default GlobalLayout;
